/* eslint-disable */

export const getBotConstants = {
    GET_BOT_REQUEST: 'GET_BOT_REQUEST',
    GET_BOT_SUCCESS: 'GET_BOT_SUCCESS',
    GET_BOT_FAILURE: 'GET_BOT_FAILURE',
};
